export const WorkGangReportSchema = {
  sections: [
    {
      heights: {
        header1: "50px",
      },
      minDataRowsCount: 10,
      columns: [
        {
          title: "Employee Name",
          colSpan: 6,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "Employee",
        },

        {
          title: "Time (hrs)",
          colSpan: 6,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "time",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/WorkGangReport/WorkGangReportSchema.js